import styled from 'styled-components';
import Link from 'next/link';
import { Breakpoints } from '../../../styled/constants';
import { FlexColumn, FlexibleDiv } from '../../../styled/common';
import { tagStyles } from '../../ui/Typography/styles';

export const ApartmentTypesOuter = styled.div`
  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 40px;
    background-color: rgba(231, 231, 231, 0.8);
    border-radius: 14px;
    transition: background-color 0.2s ease-in-out;
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.colors.background.primary};
    }
  }
`;

export const ApartmentTypesContainer = styled(FlexibleDiv)`
  display: none;

  @media (min-width: ${Breakpoints.desktop}px) {
    display: flex;
    align-items: center;
    width: 100%;
    height: 90px;
    margin: 30px 0;
    gap: 71px;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    & > * {
      flex: 0 0 auto;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ApartmentItem = styled(FlexColumn)`
  gap: 5px;
`;

export const ApartmentItemValue = styled(Link)`
  white-space: nowrap;
  ${tagStyles.h5_new};

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`;
